export default __webpack_public_path__ + "static/media/logo-digitalocean.2a34c59e.svg";